import { render, staticRenderFns } from "./index_list.vue?vue&type=template&id=083f9f58&scoped=true"
import script from "./index_list.vue?vue&type=script&lang=js"
export * from "./index_list.vue?vue&type=script&lang=js"
import style0 from "./index_list.vue?vue&type=style&index=0&id=083f9f58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f9f58",
  null
  
)

export default component.exports